import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'glxy-blank-value',
  template: ` <div class="symbol">—</div> `,
  styleUrls: ['./blank-value.scss'],
  imports: [CommonModule],
})
export class BlankValueComponent {}

@Component({
  selector: 'glxy-blank-value-renderer',
  template: ` <glxy-blank-value /> `,
  imports: [CommonModule, BlankValueComponent],
})
export class BlankValueRendererComponent {}
